import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { BrandProvider } from "@/lib/brand";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";

import SplitLanding from "@/pages/SplitLanding";
import AcademyHome from "@/pages/AcademyHome";
import Courses from "@/pages/Courses";
import Prompts from "@/pages/Prompts";
import EditBaeHome from "@/pages/EditBaeHome";
import CaseStudy from "@/pages/CaseStudy";
import { BlogIndex, BlogPost } from "@/pages/Blog";
import { Login, Register } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Redeem from "@/pages/Redeem";
import Admin from "@/pages/Admin";

function Shell({ children }) {
  const loc = useLocation();
  const isLanding = loc.pathname === "/";
  return (
    <div className="grain">
      {!isLanding && <Navbar />}
      <main>{children}</main>
      {!isLanding && <Footer />}
      {!isLanding && <Chatbot />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <BrandProvider>
        <AuthProvider>
          <Toaster theme="dark" position="top-center" />
          <Shell>
            <Routes>
              <Route path="/" element={<SplitLanding />} />
              <Route path="/academy" element={<AcademyHome />} />
              <Route path="/academy/courses" element={<Courses />} />
              <Route path="/academy/prompts" element={<Prompts />} />
              <Route path="/studio" element={<EditBaeHome />} />
              <Route path="/studio/case/:slug" element={<CaseStudy />} />
              <Route path="/media" element={<EditBaeHome />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/redeem" element={<Redeem />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Shell>
        </AuthProvider>
      </BrandProvider>
    </BrowserRouter>
  );
}

export default App;
